// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fkgd","toggle":"styles_toggle__1euVN","preview":"styles_preview__1KWBK"};